(function () {
    'use strict';

    angular
        .module('app.salespoints')
        .controller('SalespointsAddController', AddController);

    AddController.$inject = ['$location', 'SalespointsService'];

    function AddController($location, Service) {

        /* jshint validthis:true */
        var vm = this;

        vm.title = '';

        vm.entity = {};

        vm.fields = Service.getFields();

        vm.create = function () {
            if (vm.form.$valid) {
                vm.loading = true;
                vm.entity.Media = null;
                Service.add(vm.entity).then(function (data) {
                    vm.loading = false;
                    $location.path('/salespoints/detail/' + data.Id);
                });
            }
        };
    }
})();